export const SET_PLATFORM = "SET_PLATFORM";

export function setPlatform(platform) {
  return {
    type: SET_PLATFORM,
    payload: { platform }
  };
}



// WEBPACK FOOTER //
// ./src/common/device/actions.js